import { Link } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';
import { SuggestedCategory } from '../../interfaces/Suggestion/SuggestedCategory';

type CategoryCardProps = {
  category: SuggestedCategory;
};

export const CategoryCard = ({ category }: CategoryCardProps) => {
  return (
    <Link to={`/kategori/${category.slug}`} style={{ textDecoration: 'none' }}>
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: 120,
          alignItems: 'center',
          justifyContent: 'center',
          p: 2.5,
          boxSizing: 'border-box',
        }}
      >
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 600,
            textAlign: 'center',
          }}
        >
          {category.name}
        </Typography>
      </Paper>
    </Link>
  );
};
